<template>
  <div
    v-if="showBilliePaymentInfo"
    class="flex gap-1"
  >
    <div class="text-xs flex-1 self-center">
      {{ $t('NEW: Businesses can pay in 30 days with') }}
    </div>
    <div class="w-20 flex-none self-start">
      <ImgView
        src="/icons/paymentMethods/billie-borderless.svg"
        alt="Billie BNPL"
        img-classes="w-20"
      />
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'BilliePaymentInfo',

  setup() {

    const { hasTranslation } = useTranslationCheck();
    const showBilliePaymentInfo = hasTranslation('NEW: Businesses can pay in 30 days with');

    return {
      showBilliePaymentInfo,
    };
  
  },
});

</script>
